import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { GetExpenseItemCorrectionFormDataUseCase } from './GetExpenseItemCorrectionFormDataUseCase'

export const getExpenseItemCorrectionFormDataUseCase =
  new GetExpenseItemCorrectionFormDataUseCase({
    expenseRepository,
  })

export { GetExpenseItemCorrectionFormDataUseCase } from './GetExpenseItemCorrectionFormDataUseCase'
